import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { FormattedMessage, useIntl } from '@edx/frontend-platform/i18n';
import { Form, Hyperlink } from '@openedx/paragon';
import PropTypes from 'prop-types';

import messages from '../../messages';

const TermsOfService = (props) => {
  const { formatMessage } = useIntl();
  const {
    errorMessage, onChangeHandler, value,
  } = props;

  return (
    <div id="terms-of-service" className="micro text-muted">
      <Form.Checkbox
        className="form-field--checkbox mt-1"
        id="tos"
        checked={value}
        name="terms_of_service"
        value={value}
        onChange={onChangeHandler}
      >
        <FormattedMessage
          id="newsletter1"
          defaultMessage="Mă abonez: vreau să primesc pe email noutăți despre cursurile organizate pe această platformă și alte informații despre activitatea Predau Viitor."
          description="Text that appears on registration form stating terms of service.
                       It is a legal document that users must agree to."
          // values={{
          //   platformName: getConfig().SITE_NAME,
          //   termsOfService: (
          //     <Hyperlink variant="muted" destination={getConfig().TOS_LINK || '#'} target="_blank">
          //       {formatMessage(messages['terms.of.service'])}
          //     </Hyperlink>
          //   ),
          // }}
        />
      </Form.Checkbox>
    </div>
  );
};

TermsOfService.defaultProps = {
  errorMessage: '',
  value: false,
};

TermsOfService.propTypes = {
  errorMessage: PropTypes.string,
  onChangeHandler: PropTypes.func.isRequired,
  value: PropTypes.bool,
};

export default TermsOfService;
